import styled from "styled-components";

export const Container = styled.div`
  margin: 80px auto;
  height: calc(100% - 80px);
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: var(--velotax-background-color-ghost);

  .content {
    min-height: 100%;
    margin: 0 auto;
    max-width: calc(100% - 128px);
    padding: 100px 0;
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: column;

    h1 {
      font-weight: 400;
      font-size: 2rem;
      line-height: 2.5rem;
      color: var(--white);
      margin: 0 0 48px;
    }
  }

  @media only screen and (max-device-width: 812px) {
    .content {
      max-width: 100%;
      padding: 64px 0 100px;
      border-left: none;

      h1 {
        font-weight: 700;
        font-size: 1.5rem;
        line-height: 2rem;
        color: var(--velotax-font-color);
        margin: 0 0 48px 16px;
      }
    }
  }
`;
